
import { Link } from "react-router-dom";
import RegisterForm from "@/components/auth/RegisterForm";

const Register = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 rounded-xl bg-white p-8 shadow-md">
        <div className="text-center">
          <Link to="/" className="inline-block">
            <img src="/lovable-uploads/60f073cd-316e-4fa1-9add-c6553bdb9ac9.png" alt="Scaloo" className="h-10 mx-auto" />
          </Link>
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">
            Créer un compte
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Ou{" "}
            <Link
              to="/login"
              className="font-medium text-socialsync-600 hover:text-socialsync-500"
            >
              connectez-vous à votre compte existant
            </Link>
          </p>
        </div>

        <RegisterForm />
      </div>
    </div>
  );
};

export default Register;
